/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';

const featuredVideos = [
  {
    id: 1,
    title: 'The Woman Worth Hearing - Clip 1',
    src: 'https://d1zx0zj5kmre28.cloudfront.net/videos/TWW_Website_clip_1.mp4',
  },
  {
    id: 2,
    title: 'The Woman Worth Hearing - Clip 2',
    src: 'https://d1zx0zj5kmre28.cloudfront.net/videos/TWW_Website_clip_2.mp4',
  },
  {
    id: 3,
    title: 'The Woman Worth Hearing - Clip 3',
    src: 'https://d1zx0zj5kmre28.cloudfront.net/videos/TWW_Website_clip_3.mp4',
  },
];

export default function WomansPage() {
  const navigate = useNavigate();
  const [titles, setTitles] = useState([]);
  useDocumentTitle(`Women | Pastor Chris Digital Library`);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(
          'https://nmt.loveworldapis.com/api/pcdl/lists/messages',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: 'wailingwomen' }),
          },
        );

        const data = await res.json();
        setTitles(data.data || data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Hero */}
        <section
          className="relative flex min-h-[320px] items-center bg-cover bg-center px-5 py-20 sm:min-h-[400px] sm:px-10 lg:min-h-[500px]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.45)), url("./Women_1.jpg")',
          }}
        >
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold leading-none tracking-[-2px] sm:text-6xl lg:text-7xl">
              <span className="italic font-normal">Life Changing</span>
              <br />
              <span className="italic">Lessons</span>
              <br />
              <span className="text-[#FFFF4F] italic">For Women</span>
            </h1>
          </div>
        </section>

        {/* Intro Text */}
        <section className="py-12 sm:py-16">
          <div className="mx-auto max-w-4xl space-y-6 text-base leading-8 text-white/90 sm:text-lg">
            <p>
              The Word of God offers wisdom and guidance for every area of life.
              From the beginning God created women with purpose, dignity and a
              unique role to fulfill. Yet many women today experience confusion,
              pain and uncertainty—often rooted in a lack of spiritual
              understanding.
            </p>

            <p>
              By exploring the timeless truths found in Scripture, you can
              discover powerful insights that bring clarity, healing, and
              direction. These hidden gems from God&apos;s Word have the power
              to transform your perspective and change your life forever.
            </p>
          </div>
        </section>

        {/* Video Clips Section */}
        <section className="py-10 sm:py-14">
          <div className="mb-8 items-center flex flex-col">
            <h2 className="text-3xl font-bold italic tracking-[-1px] sm:text-5xl">
              Featured Videos
            </h2>
            <p className="mt-3 max-w-2xl text-white/75 w-full">
              Watch inspiring clips from The Woman Worth Hearing series.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {featuredVideos.map((video) => (
              <div
                key={video.id}
                className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-lg"
              >
                <video
                  src={video.src}
                  controls
                  preload="metadata"
                  playsInline
                  className="aspect-video w-full bg-black object-cover"
                />
              </div>
            ))}
          </div>
        </section>

        {/* Full Messages */}
        <section className="py-10 sm:py-14">
          <div className="mb-8">
            <h2 className="text-xl font-bold text-white sm:text-2xl">
              Get The Full Messages
            </h2>
          </div>

          <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {titles.map((item) => (
              <a
                href={`/watch/${item.id}`}
                target="_blank"
                rel="noopener noreferrer"
                key={item.id}
                className="group block flex flex-col items-center"
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="h-40 rounded-xl object-contain aspect-square transition duration-300 group-hover:opacity-80"
                />
                <h3 className="mt-3 line-clamp-2 text-sm font-semibold text-white sm:text-base">
                  {item.title}
                </h3>
              </a>
            ))}
          </div>
        </section>

        {/* Testimonies */}
        <section className="flex flex-col gap-8 py-12 sm:py-16 lg:flex-row lg:items-center lg:justify-between">
          <div className="mx-auto flex flex-col items-center">
            <Link to="/subscription?type=gold-star" className="w-fit">
              <img
                src="/Gift_of_Subscriptions_WHITE_Logo.png"
                alt="Gift of Subscriptions"
                className="h-30 w-auto rounded-xl object-contain sm:h-32"
              />
            </Link>
            <p className="mt-6 max-w-xl text-white/80">
              Join us today and become a partner as we gift Pastor Chris Digital Library Subscriptions around the world!

            </p>
          </div>
        </section>

        {/* Community CTA */}
        <section
          className="relative flex min-h-[400px] items-start bg-cover bg-center px-5 py-14 sm:min-h-[500px] sm:px-10 max-h-[20rem]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.45)), url("./Women_2.jpg")',
          }}
        >
          <div className="w-full max-auto">
            <h2 className="text-4xl font-bold leading-tight tracking-[-2px] sm:text-5xl mb-10">
              <span className="italic font-normal">Join Our Global </span>
              <span className="italic">Womens </span>
              <span className="text-[#ffff4f] italic">Community</span>
            </h2>

            <a
              type="button"
              className="mt-8 rounded-md bg-[#E71D72] px-5 py-3 text-sm font-bold text-white transition hover:opacity-90"
              href="https://loveworldladiesnetwork.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign Up Today!
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}
